
import Booking from "@model/promotion/Booking.js";
import Kill from "@model/promotion/Kill.js";
import OrderReduce from "@model/promotion/OrderReduce.js";
import Subscribe from "@model/promotion/Subscribe.js";
import SubscribeSnap from "@model/promotion/SubscribeSnap.js";
import Factory from "./Factory.js";
import Constant from "@constant/index.js";

export default class PromotionFactory extends Factory {
    constructor(){
        super();
    }
}

PromotionFactory.prototype[Constant.PROMOTION_TYPE.BOOKING.TYPE] = function(data){
    let _booking = new Booking();
    _booking.init(data);
    return _booking;
}

PromotionFactory.prototype[Constant.PROMOTION_TYPE.KILL.TYPE] = function(data){
    let _kill = new Kill(data);
    _kill.init(data);
    return _kill;
}

PromotionFactory.prototype[Constant.PROMOTION_TYPE.KILL_COUNTDOWN.TYPE] = function(data){
    let _kill = new Kill(data);
    _kill.init(data);
    return _kill;
}

PromotionFactory.prototype[Constant.PROMOTION_TYPE.ORDER_REDUCE.TYPE] = function(data){
    let _orderReduce = new OrderReduce(data);
    _orderReduce.init(data);
    return _orderReduce;
}

PromotionFactory.prototype[Constant.PROMOTION_TYPE.SUBSCRIBE.TYPE] = function(data){
    let _subscribe = new Subscribe(data);
    _subscribe.init(data);
    return _subscribe;
}

PromotionFactory.prototype[Constant.PROMOTION_TYPE.SUBSCRIBE_SNAP.TYPE] = function(data){
    let _subscribeSnap = new SubscribeSnap(data);
    _subscribeSnap.init(data);
    return _subscribeSnap;
}